import React from 'react';
import HomePageHeader from '../HomePageHeader';
import Footer from '../HomePageFooter';
import ImageHeading from './ImageHeading';

const OurAim = () => {

    const renderAimSection = () => {
        return (
            <section className='legal pt-5 pb-5'>
                <div className='container'>
                    <div className="row">
                        <div className="pr-heading aim">
                            <h1>
                                Our Aim
                            </h1>
                        </div>
                    </div>
                    <div className='row'>
                        <p>The aim of the college is to offer an all round education to the students drawing insiration from the life and teaching of Jesus Christ.</p>
                        <p>The College is to impart sound learning, the building of character and spread of spiritual and knowledge of God.</p>
                        <p>Religious instructions based on the Bible, is a part of the College curriculum but it is not forced upon those who are unwilling to receive it. It is hoped that those who join the College will do so with the desire to receive the best possible education of spirit, body and mind which the College seeks to provide for all its members.</p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <HomePageHeader />
            <ImageHeading heading='Aim' />
            {renderAimSection()}
            <Footer />
        </>
    );
}

export default OurAim;